import React, { ReactNode } from 'react';
import {
  ArrowLeftIcon,
  Box,
  Heading,
  Link,
  Button,
  PlusIcon,
} from '@razorpay/blade/components';

interface WorkflowLayoutProps {
  title: ReactNode;
  onBackButtonClick?: () => void;
  onCreateClick?: () => void;
  children: JSX.Element | JSX.Element[];
  showCreateButton?: boolean;
}

const SideNavContainer = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  return (
    <Box
      minWidth="224px"
      padding="spacing.5"
      borderRightWidth="thin"
      borderRightColor="surface.border.gray.subtle"
      borderRightStyle="solid"
      backgroundColor="surface.background.gray.moderate"
      display="flex"
      flexDirection="column"
      gap="spacing.5">
      {children}
    </Box>
  );
};

const MainContentContainer = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  return (
    <Box
      as="section"
      flexGrow={1}
      height="100%"
      display="flex"
      flexDirection="column"
      backgroundColor="surface.background.gray.moderate">
      {children}
    </Box>
  );
};

const RightPanelContainer = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  return (
    <Box
      minWidth="400px"
      maxWidth="400px"
      padding="spacing.6"
      borderLeftWidth="thin"
      borderLeftColor="surface.border.gray.subtle"
      borderLeftStyle="solid"
      backgroundColor="surface.background.gray.subtle"
      overflowY="auto">
      {children}
    </Box>
  );
};

const WorkflowLayout = ({
  title,
  children,
  onBackButtonClick,
  onCreateClick,
  showCreateButton = false,
}: WorkflowLayoutProps) => {
  const showBackButton = !!onBackButtonClick;

  return (
    <Box height="100vh" display="flex" flexDirection="column" position="relative" overflow="hidden">
      <Box
        padding={['spacing.5', 'spacing.8']}
        display="flex"
        alignItems="center"
        gap="spacing.8"
        backgroundColor="surface.background.gray.subtle"
        borderBottomWidth="thin"
        borderBottomColor="surface.border.gray.normal">
        {showBackButton && (
          <Link variant="button" icon={ArrowLeftIcon} onClick={onBackButtonClick} size="large" />
        )}
        <Heading as="h1" display={'flex'} size="large">
          {title}
        </Heading>
        {showCreateButton && onCreateClick && (
          <Box marginLeft="auto">
            <Button icon={PlusIcon} onClick={onCreateClick}>
              Create Workflow
            </Button>
          </Box>
        )}
      </Box>
      <Box flexGrow={1} display="flex" overflowY="hidden">
        {children}
      </Box>
    </Box>
  );
};

export { WorkflowLayout, SideNavContainer, MainContentContainer, RightPanelContainer };

